import { useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import Info from "./Info";
import dateFormat, {
  dateFormatTime,
  formatDateTime,
  generateReferenceNumber,
} from "../../../../../utils/dateFormat";

// PDF Styles
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
  },
  section: {
    marginBottom: 10,
  },
  header: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 30,
  },
  table: {
    display: "table",
    width: "auto",
    border: "1px solid #bfbfbf",
    borderBottom: "",
  },

  tableRow: {
    borderBottom: "1px solid #dfdfdf",
    flexDirection: "row",
  },
  tableHeaderRow: {
    backgroundColor: "#0f2a58", // same deep navy as screenshot
  },
  headerText: {
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: 10,
    textAlign: "center",
    padding: 5,
  },
  // tableCol: {
  //   width: "100%",
  //   padding: 5,
  // },
  tableCol: {
    flex: 1, // Allow columns to flexibly adjust their width
    padding: 5,
  },
  tableHeader: {
    backgroundColor: "#003366",
    color: "#ffffff",
    padding: 5,
    fontWeight: "bold",
  },
  // tableCell: {
  //   fontSize: ".15in",
  //   textAlign: "center",
  // },
  tableCell: {
    fontSize: ".09in",
    textAlign: "center",
  },
  disclaimer: {
    marginTop: 20,
    fontSize: 12,
    textAlign: "start",
    fontStyle: "italic",
  },
});

// PDF Document layout
const MyDocument = ({ searchLog, user, isFinances, userLoggedin }) => {
  console.log("sssss", searchLog);
  // const data = [
  //   {
  //     searchedName: `${searchLog?.searched_first_name || ""} ${
  //       searchLog?.searched_middle_name || ""
  //     } ${searchLog?.searched_last_name || ""} ${
  //       searchLog?.searched_alias || ""
  //     }`,
  //     client:
  //       searchLog?.affiliateName ||
  //       searchLog?.searcher?.affiliateName ||
  //       "Negative Records",
  //     inquiryBy: `${user.firstName || ""} ${user?.middleName || ""} ${
  //       user?.lastName || ""
  //     }`,
  //     inquiryDate: formatDateTime(searchLog?.createdAt),
  //     referenceNo: searchLog?.referenceNo,
  //   },
  // ];

  const data = isFinances
    ? [
        {
          name: `${searchLog?.searched_first_name || ""} ${
            searchLog?.searched_middle_name || ""
          } ${searchLog?.searched_last_name || ""} ${
            searchLog?.searched_alias || ""
          }`,
          // inquiryDate: dateFormatTime(searchLog?.createdAt),
          inquiryDate: dateFormatTime(new Date()),
          inquiryBy: `${userLoggedin[0]?.firstName || ""} ${
            userLoggedin[0]?.middleName || ""
          } ${userLoggedin[0]?.lastName || ""}`,
          client: userLoggedin[0]?.affiliate?.name || "None",
          branch: userLoggedin[0]?.branch?.name || "None",
          referenceNo: generateReferenceNumber(),
        },
      ]
    : [
        {
          name: `${searchLog?.searched_first_name || ""} ${
            searchLog?.searched_middle_name || ""
          } ${searchLog?.searched_last_name || ""} ${
            searchLog?.searched_alias || ""
          }`,
          // dateLocked: dateFormatTime(searchLog?.createdAt),
          // inquiryDate: dateFormatTime(searchLog?.createdAt),
          inquiryDate: dateFormatTime(new Date()),
          // dateLocked: dateFormat(caseInfo?.createdAt),
          // inquiryBy: caseInfo?.lockedTo
          //   ? `${caseInfo?.lockedTo.firstName || ""} ${
          //       caseInfo?.lockedTo.middleName || ""
          //     } ${caseInfo?.lockedTo.lastName || ""}`
          //   : "None",
          inquiryBy: `${userLoggedin[0]?.firstName || ""} ${
            userLoggedin[0]?.middleName || ""
          } ${userLoggedin[0]?.lastName || ""}`,
          client: userLoggedin[0]?.affiliate?.name || "None",
          branch: userLoggedin[0]?.branch?.name || "None",
          referenceNo: generateReferenceNumber(),
        },
      ];
  return (
    <Document>
      <Page style={styles.page}>
        {/* Header */}
        <Text style={styles.header}>NEGATIVE RECORDS DETAIL REPORT</Text>
        <View
          style={{ display: "flex", flexDirection: "column", gap: ".25in" }}
        >
          <Info styles={styles} data={data} />
          <View style={[styles.section, styles.table]}>
            {/* Header row */}
            <View style={[styles.tableRow, styles.tableHeaderRow]}>
              <View style={styles.tableCol}>
                <Text style={styles.headerText}>Case No.</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.headerText}>Case Type</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.headerText}>Plaintiff</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.headerText}>Date Filed</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.headerText}>City</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.headerText}>Court</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.headerText}>Branch</Text>
              </View>
            </View>

            {/* Single full-width "not found" row */}
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, styles.fullWidthCol]}>
                <Text style={styles.tableCell}>CourtCase Not Found</Text>
              </View>
            </View>
          </View>
          <Info styles={styles} label="Court Case" />
          <Info styles={styles} data={[]} label="Bounce Check" />
          <Info styles={styles} data={[]} label="Watch List" />
          <Info styles={styles} data={[]} label="Telecoms" />
          <Info styles={styles} data={[]} label="Declined" />
          <Info styles={styles} data={[]} label="Delinquent" />
          <View>
            <Text>Disclamer</Text>
            <Text style={styles.disclaimer}>
              Disclaimer: This report, to be treated in strictest confidence,
              upon request and in accordance with the subscription agreement
              entered into by and between Forbes Financial Consultancy
              Corporation (FFCC) and the user, the terms of which agreement are
              hereby incorporated by reference, for exclusive use as one factor
              to be considered in connection with credit, insurance, marketing,
              and other business decisions, and for no other purpose. It may
              contain information from sources which FFCC does not control and
              which information, unless otherwise indicated, may not have been
              verified. It shall not be used as evidence in any legal proceeding
              nor shall it be shown to subject or others, and neither shall its
              source be disclosed. FFCC has acted with due diligence and in
              utmost good faith and does not guarantee the accuracy,
              completeness, and timeliness of this report or does it assume any
              part of the user's risk in its use or non-use. FFCC shall not and
              cannot be held liable for any loss, injury or damage caused or may
              hereafter be caused, directly or indirectly, by the use of the
              report or arising from the acts on the part of FFCC, its officers,
              agents, and personnel relative to the procurement, collection,
              and/or communication of any information relative thereto. Any
              point of clarification may be promptly raised solely and
              exclusively with FFCC.
            </Text>
          </View>
        </View>

        {/* Disclaimer */}
      </Page>
    </Document>
  );
};

export default function NoResultState2({
  searchLog,
  user,
  onClickSaveNoRecord,
  isFinances,
  userLoggedin,
}) {
  console.log("LOGGG", searchLog);
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    if (clicked) return;
    setClicked(true);
    onClickSaveNoRecord(searchLog);
  };

  return (
    <div className="mt-3">
      <p>
        Search result for{" "}
        <span className="text-primary fw-semibold">
          {`${searchLog?.searched_first_name || ""} ${
            searchLog?.searched_middle_name || ""
          } ${searchLog?.searched_last_name || ""} ${
            searchLog?.searched_alias || ""
          }`}
        </span>
      </p>
      <p
        onClick={handleClick}
        style={{ pointerEvents: clicked ? "none" : "auto", opacity: clicked ? 0.5 : 1 }}
      >
        This name does not exist in our negative records.{" "}
        <PDFDownloadLink
          document={
            <MyDocument
              searchLog={searchLog}
              user={user}
              isFinances={isFinances}
              userLoggedin={userLoggedin}
            />
          }
          fileName="negative_records_report.pdf"
          className="fw-semibold"
          style={{ color: "blue", cursor: clicked ? "default" : "pointer" }}
        >
          {({ loading }) => (loading ? "Generating PDF..." : "Print details")}
        </PDFDownloadLink>
      </p>
    </div>
  );
}
